












































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { fetchCambioServicio } from './fetchCambioServicio';
import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import moment from 'moment';
import { Snotify } from '@/snotify/Snotify';

@Component({
  components: {
    DatePicker,
    FormFieldsContainer,
  },
})
export default class CabezeraCS extends Vue {
  constructor() {
    super();
  }

  @Prop({ default: null }) accion_modal: any;
  @Prop({ default: null }) id_cs: any;
  readonly $snotify: Snotify;

  filtro_coordinador: any[] = [];
  filtro_tecnicos: any[] = [];
  model_filtro_anulado: any = null;
  filtro_anulado: any = null;
  que_mostrar: any = {
    serienumero: '',
    tipoeqid: '',
    accion_de_cambio: '',
    tecnico_id: '',
  };
  readonly loadingService = new LoadingService();
  // Inicializar accion en data()

  async mounted() {
    this.get_estimated_altaserv_num();
    this.get_estados_anulacion();
    this.get_listas_coordinadores();
    this.get_estimated_altaserv_num();
  }

  async get_estados_anulacion() {
    this.loadingService.showLoading(undefined, 'get_estados_anulacion');
    return fetchCambioServicio(
      {},
      'conectaCambioServicio/get_estados_anulacion'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('get_estados_anulacion');
        this.filtro_anulado = data.data.TIPO_ANULACIONES;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  } //end get_estados_anulacion

  formFields: FormFieldDefMap = {
    numero_cambio_servicio: {
      label: 'Número Cambio de Servicio',
      id: '',
      value: '',
    },
    fecha_de_alta: {
      label: 'Fecha de Registro',
      id: '',
      value: moment(),
    },
    fecha_de_instalacion: {
      label: 'Fecha de SerTec',
      id: '',
      value: '',
    },
    numero_orden: {
      label: 'Número de Orden',
      id: '',
      value: '',
    },
    observacion: {
      label: 'Observación',
      id: '',
      value: '',
    },
    referencia: {
      label: 'Referencia',
      id: '',
      value: '',
    },
    coordinador: {
      label: 'Coordinador',
      id: '',
      value: '',
    },
    tecnico_vigente: {
      label: 'Técnico',
      id: '',
      value: '',
    },
    model_filtro_anulado: {
      label: 'Estado',
      id: '',
      value: '',
    },
  };

  async get_listas_coordinadores() {
    this.loadingService.showLoading(undefined, 'get_listas_coordinadores');
    return fetchCambioServicio({}, 'conectaCambioServicio/get_coordinadores')
      .then((data: any) => {
        this.loadingService.hideLoading('get_listas_coordinadores');
        this.filtro_coordinador = data.data.data2.LISTA;
        this.filtro_tecnicos = data.data.data.LISTA;
        //this.filtro_coordinador = data.data.LISTA;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  } //end get_listas_coordinadores

  async datos_detalle(numero_cambio_servicio: any) {
    this.loadingService.showLoading();
    return fetchCambioServicio(
      { cambiosernumero: numero_cambio_servicio },
      'conectaCambioServicio/informacion_servicio'
    )
      .then((data: any) => {
        this.loadingService.hideLoading();
        this.formFields.fecha_de_alta.value = moment(
          data.data.cambioserfecha_alta
        ).format('DD/MM/YYYY');
        this.formFields.fecha_de_instalacion.value = moment(
          data.data.cambioserfecha_instala
        ).format('DD/MM/YYYY');
        this.formFields.observacion.value = data.data.cambioserobs;
        this.formFields.referencia.value = data.data.cambioserref;
        this.formFields.numero_orden.value = data.data.cambioserorden_numero;
        this.formFields.coordinador.value = data.data.coorid;
        this.formFields.tecnico_vigente.value = data.data.tecnicoid;
        this.que_mostrar.serienumero = data.data.serienumero;
        this.que_mostrar.tipoeqid = data.data.tipoeqid;
        this.que_mostrar.tecnico_id = data.data.tecnicoid;
        if (data.data.cambiosernuevo_activo_cliente == 't') {
          this.que_mostrar.accion_de_cambio = 'cambiosernuevo_activo_cliente';
          this.que_mostrar.cliente_id_saliente = data.data.clienterut;
          this.que_mostrar.flota_saliente = data.data.flota_id;
          this.que_mostrar.patente_saliente = data.data.patente_vehiculo;
          this.que_mostrar.cliente_id_entrante = data.data.cambioclienterut;
          this.que_mostrar.flota_entrante = data.data.cambioflota_id;
          this.que_mostrar.patente_entrante = data.data.cambiopatente_vehiculo;
          this.$emit('activar_modo', this.que_mostrar);
        } else if (data.data.cambiosernuevo_equipo == 't') {
          this.que_mostrar.accion_de_cambio = 'cambiosernuevo_equipo';
          this.que_mostrar.serienumero_entrante = data.data.cambioserienumero;
          this.que_mostrar.tipoeq_entrante = data.data.cambiotipoeqid;
          this.$emit('activar_modo', this.que_mostrar);
        } else if (data.data.cambioserretira_equipo == 't') {
          this.que_mostrar.accion_de_cambio = 'cambioserretira_equipo';
          this.$emit('activar_modo', this.que_mostrar);
        } else if (data.data.cambiosernuevo_sim == 't') {
          this.que_mostrar.accion_de_cambio = 'cambiosernuevo_sim';
          this.que_mostrar.simserienumero = data.data.simserienumero;
          this.que_mostrar.cambiosimserienumero =
            data.data.cambiosimserienumero;
          this.$emit('activar_modo', this.que_mostrar);
        } else {
          this.$snotify.error(
            'No fue posible determinar la Operación, intente de nuevo',
            { timeout: 3000 }
          );
        }
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
    //}
  } //end get_estimated_altaserv_num
  async get_estimated_altaserv_num() {
    if (this.accion_modal == 'EDITAR') {
      this.formFields.numero_cambio_servicio.value = this.id_cs;
      this.datos_detalle(this.formFields.numero_cambio_servicio.value);
      return null;
    }

    this.loadingService.showLoading(undefined, 'get_estimated_altaserv_num');
    return fetchCambioServicio(
      { '': '' },
      'conectaCambioServicio/get_estimated_cambioserv_num'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('get_estimated_altaserv_num');
        this.formFields.numero_cambio_servicio.value = data.data.id;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
    //}
  } //end get_estimated_altaserv_num
  @Watch('formFields')
  onModelTipoCambioChanged(val: any, oldVal: any) {
    this.$emit('input', this.formFields);
  }
  enviar_tecnico() {
    this.$emit('enviarTecnico', this.formFields.tecnico_vigente.value);
  }
  enviarNumero() {
    this.$emit('enviarNumero', this.formFields.numero_cambio_servicio.value);
  }
  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }
  get fechaMaximaInicio() {
    //let fechaMax = this.formFields.fechaInicio.value;

    return moment(this.fechaMaxima) as moment.Moment;
    //return fechaMax as moment.Moment;
  }
} //end class
